import { environment } from '../../environments/environment';

/** Environments where the fake-JWT dev login flow is available. */
const FAKE_LOGIN_ENVIRONMENTS = ['local', 'development'];

/** Environments treated as non-production for test-only UI affordances. */
const TEST_ENVIRONMENTS = ['local', 'testing', 'development'];

/** Environments where the "Job(s)" menu is available. */
const JOBS_MENU_ENVIRONMENTS = ['local', 'testing', 'development', 'acceptance'];

/** Environments where logoff clears the local fake cookie instead of SSO logout. */
const DEV_LOGOFF_ENVIRONMENTS = ['local', 'development'];

export function isFakeLoginEnabled(): boolean {
  return FAKE_LOGIN_ENVIRONMENTS.includes(environment.name);
}

export function isTestEnvironment(): boolean {
  return TEST_ENVIRONMENTS.includes(environment.name);
}

export function isJobsMenuEnabled(): boolean {
  return JOBS_MENU_ENVIRONMENTS.includes(environment.name);
}

export function isDevLogoffEnabled(): boolean {
  return DEV_LOGOFF_ENVIRONMENTS.includes(environment.name);
}

/** Domains an external login redirect is permitted to target. */
const ALLOWED_REDIRECT_HOSTS = ['youforce.com', 'youforceacc.com', 'youforcetest.com'];

/** Guards against open redirects: only allow https Youforce login hosts. */
export function isAllowedRedirectUrl(url: string | null | undefined): url is string {
  if (!url) {
    return false;
  }
  try {
    const parsed = new URL(url);
    if (parsed.protocol !== 'https:') {
      return false;
    }
    return ALLOWED_REDIRECT_HOSTS.some(
      (host) => parsed.hostname === host || parsed.hostname.endsWith('.' + host)
    );
  } catch {
    return false;
  }
}
